const setupBigIntJSON = () => {
    const originalStringify = JSON.stringify
    const originalParse = JSON.parse

    JSON.stringify = function (value, replacer, space) {
        try {
            const customReplacer = (key, val) => {
                if (typeof val === 'bigint') {
                    return `${val}n`
                }
                return typeof replacer === 'function' ? replacer(key, val) : val
            }
            return originalStringify(value, customReplacer, space)
        } catch (e) {
            return originalStringify(value, null, space)
        }
    }

    JSON.parse = function (text, reviver) {
        try {
            const customReviver = (key, val) => {
                if (typeof val === 'string' && /^[0-9]+n$/.test(val)) {
                    return BigInt(val.slice(0, -1))
                }
                return typeof reviver === 'function' ? reviver(key, val) : val
            }
            return originalParse(text, customReviver)
        } catch (e) {
            return originalParse(text)
        }
    }
}

export default setupBigIntJSON
